// extracted by mini-css-extract-plugin
export default {"logoImg":"AdminMobileStartPage_logoImg__FH0G1","logoTxt":"AdminMobileStartPage_logoTxt__tTMBQ"};